import juniAxios from 'services/axios';

export async function getAdditionalClassesForLoggedInParent() {
  return (await juniAxios.get(`/learner/additional_classes`)).data.data;
}
